import { datadogRum } from '@datadog/browser-rum'
import { datadogLogs } from '@datadog/browser-logs'

const isProduction = Pura?.environment?.production ?? false
window.__PURA_SHOPIFY_THEME_VERSION__ = __PURA_SHOPIFY_THEME_VERSION__

datadogRum.init({
  applicationId: isProduction
    ? 'a472d657-19a2-4d80-b5f7-8654dce4eff2'
    : '3c4711b1-879c-445d-9652-366788321f21',
  clientToken: isProduction
    ? 'pub38db3cc767572d831a106766fa753e13'
    : 'pub1613d71aacfa194f77a8f5e93d73e8b8',
  site: 'datadoghq.com',
  service: isProduction ? 'web-prod' : 'web-stage',
  env: isProduction ? 'prod' : 'staging',
  version: __PURA_SHOPIFY_THEME_VERSION__ || 'unknown',
  sessionSampleRate: isProduction ? 1 : 100,
  sessionReplaySampleRate: 0,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input',
})

if (Pura?.customer) {
  datadogRum.setUser({
    id: Pura.customer.key,
    name: `${Pura.customer.first_name} ${Pura.customer.last_name}`,
    email: Pura.customer.email,
  })
} else {
  datadogRum.removeUserProperty('name')
  datadogRum.removeUserProperty('id')
  datadogRum.removeUserProperty('email')
}

datadogLogs.init({
  clientToken: 'pub0c762e92bef5b7398c8e67acec220c42',
  site: 'datadoghq.com',
  forwardErrorsToLogs: true,
  sessionSampleRate: 100,
  service: 'shopify',
  env: 'prd',
})
